var stateProviders = [];

//For Tests
var endPointResponses = {};

String.prototype.trim = null;

String.prototype.trim = function() {
	return this.replace(/^\s+|\s+$/g,'');
}

function strToLower (str) {
  return (str + '').toLowerCase();
}

function nl2br (str, is_xhtml) {
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

String.prototype.addCommas = function ()
{
    let nStr = this;
    nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
}

String.prototype.addition = function (x)
{
    if (x == "" || x === null)
        x = "0";
    return parseInt(this) + parseInt(x);
 }

String.prototype.subtraction = function (x)
{
    if (x == "")
        x = "0";
    return parseInt(this) - parseInt(x);
}

Number.prototype.addition = function (x)
{
    if (x == "")
        x = "0";
    return parseInt(this) + parseInt(x);
}

Number.prototype.subtraction = function (x)
{
    if (x == "")
        x = "0";
    return parseInt(this) - parseInt(x);
}

Date.prototype.getDateMySqlFormatted = function() {
    return this.getFullYear() + '-' + this.getMonthFormatted() + '-' + this.getDateFormatted();
}

String.prototype.getDateFormatted = function() {
    return this.substr(0, 4) + '-' + this.substr(4, 2) + '-' + this.substr(6, 2)
}

//following three functions used for applicant and other children DOB display
String.prototype.getDateReversed = function() {
    return this.substr(4, 2) + '-' + this.substr(6, 2) + '-' + this.substr(0, 4)
}

String.prototype.getDateMysqlReversed = function() {
    return this.substr(4, 2) + this.substr(6, 2) + this.substr(0, 4)
}

String.prototype.getDateMysqlRegular = function() {
    return this.substr(4, 4) + this.substr(0, 2) + this.substr(2, 2)
}

String.prototype.getDateMysql = function() { //05-20-2005 -> 20050520
    return this.substr(6, 4) + this.substr(0, 2) + this.substr(3, 2) 
}

Date.prototype.getMonthFormatted = function() {
    var month = this.getMonth() + 1;
    return month < 10 ? '0' + month : month; // ('' + month) for string result
}

Date.prototype.getDateFormatted = function() {
    var date = this.getDate();
    return date < 10 ? '0' + date : date; // ('' + date) for string result
}

String.prototype.replaceAll = function(str1, str2, ignore)
{
    return this.replace(new RegExp(str1.replace(/([\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, function(c){return "\\" + c;}), "g"+(ignore?"i":"")), str2);
};


function sort_unique(arr) {
    arr = arr.sort(function (a, b) { return a*1 - b*1; });
    var ret = [arr[0]];
    for (var i = 1; i < arr.length; i++) { // start loop at 1 as element 0 can never be a duplicate
        if (arr[i-1] !== arr[i]) {
            ret.push(arr[i]);
        }
    }
    return ret;
}

String.prototype.toDate = function()
{
    var string = this.replaceAll("-", "");
    var doo = new Date(string.substr(0, 4) + '-' + string.substr(4, 2) + '-' + string.substr(6, 2));
    return new Date(doo.getTime() + doo.getTimezoneOffset()*60000);
}

String.prototype.dotdotdot = function(firstcount, lastcount) {
    if (!lastcount) lastcount=null;
    if (firstcount+lastcount+3>this.length) {
        return this.toString();
    }
    else {
        return this.substr(0, firstcount--)+'...'+this.substr(this.length-lastcount, this.length);
    }
}

function flattenObj(obj) {
    var arr = [];
    for (var key in obj) {
        arr.push(obj[key]);
    }
    return arr;
}

function formatMonthDash(str)
{
    var year = str.substr(0, 4);
    var day = str.substr(4, 2);
    var month = str.substr(6, 2);
    return year + '-' + month + '-' + day;
}

var serialize = function(obj, prefix) {
    var str = [];
    for(var p in obj) {
        if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
            str.push(typeof v == "object" ?
                serialize(v, k) :
            encodeURIComponent(k) + "=" + encodeURIComponent(v));
        }
    }
    return str.join("&");
}

/*
function formatMonth(str)
{
    var year = str.substr(0, 4);
    var day = str.substr(4, 2);
    var month = str.substr(6, 2);
    return day + '/' + month + '/' + year;
}
*/
